module.exports = __webpack_public_path__ + "static/media/upload.42655dc7.svg";